import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";

import { COMN_SF_LPCO_SRCH, COMN_SG_LPCO_LIST_HEAD, COMN_SG_LPCO_LIST_BODY } from "@/tz/go/egaz/osci/lpco/cfgn/comn";

/*
 *  LPCO Component Settings
 * !== LPCO Component Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${lpcoEnvs.base}/lpco/cfgn/asin`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cfgn/asin`,
    nodes: [
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_CFGN" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO_APP_SETT" },
        { path: "/cfgn/asinctra/osci0203013s", label: "T_ASNMT_CTRA_METD_SETT" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */

export const URLS = {
    osci0203013s: `${BASE.path}/osci0203013s`, // Register Assignment Criteria   !== 배부 기준(방법) 등록  ==!
    osci0203014q: `${BASE.path}/osci0203014q`, // Register Assignment Criteria List  !== 배부 기준(방법) 구성 목록 조회  ==!
    osci0203015s: `${BASE.path}/osci0203015s`, // Register Assignment Criteria Detail  !== 배부 기준(방법) 구성 상세 조회  ==!
    osci0203016s: `${BASE.path}/osci0203016s`, // Assignment Criteria Modification  !== 배부 기준(방법) 수정 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    /* Assignment Criteria inquiry !== Assignment Criteria 목록 조회 ==! */
    getLpcoList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    /* LPCO detailed inquiry !== LPCO Component 상세 조회 ==! */
    getAppDtl: (appFmId: any) => {
        return api.get(`${BASE.api}/${appFmId}`);
    },
    getAppDtlByAppCdNo: (appCdNo: any) => {
        return api.get(`${BASE.api}/app-cd-no/${appCdNo}`);
    },
    getAsnmtDtlByAsnmtBsopTpCd: (asnmtBsopTpCd: any) => {
        return api.get(`${BASE.api}/asnmt-bsop-tp-cd/${asnmtBsopTpCd}`);
    },
    /* Register LPCO information !== LPCO Component 등록 ==! */
    saveAppAsinList: (data: any) => {
        // return api.put(`${BASE.api}/${data.asnmtBsopTpCd}/${data.appFmId}`, {
        //     ...data,
        // });
        /* FIXME: 통테서버 오류 방지를 위한 임시 하드코딩 추후 변경 */
        return api.put(`${BASE.api}/ABO03/${data.appFmId}`, {
            ...data,
        });
    },

    /* Edit LPCO information !== LPCO Component 수정 ==! */
    /* Delete LPCO information !== LPCO Component 삭제 ==! */
};

/*
 * @ Form 스키마 정의
 * @ 화면에서 사용하는 Form 구조 정의
 * @ SF_ 로 시작 (Schema form)
 * @ SF_[Form 이름 메타 대문자, "_" 로 구분 ]
 * @ 검색폼은 _SRCH 로 구분
 */
export const SF_LPCO_INFO_R: TFormSchema = {
    id: "form_LpcoInfo",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            controlSize: 10,
            edit: false,
        } /* OGA */,
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA Name */,
        appCdNo: {
            type: "select",
            label: "L_LPCO",
            required: true,
            edit: false,
        } /* L_LPCO */,
        appNm: {
            type: "text",
            label: "L_LPCO",
            required: true,
            edit: false,
        } /* L_LPCO */,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            viewType: "label",
            edit: false,
        },
    },
};

export const SF_LPCO_INFO_U: TFormSchema = {
    id: "form_LpcoInfo",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            controlSize: 10,
            edit: false,
        } /* OGA */,
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA Name */,
        asnmtBsopTpCd: {
            type: "select",
            area: "comnCd",
            comnCd: "OSC0118",
            label: "L_ASNMT_BSOP_TP",
            edit: true,
            required: true,
        } /* Assignment Business Operations Type Code */,
        appCdNo: {
            type: "select",
            label: "L_LPCO",
            edit: true,
            required: true,
        } /* L_LPCO */,
        appNm: {
            type: "text",
            label: "L_LPCO",
            edit: false,
            controlSize: 10,
        } /* L_LPCO */,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            viewType: "label",
            edit: false,
        },
    },
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

// LPCO Search Schema !== LPCO Search Schema ==!
export const SF_LPCO_SRCH: TFormSchema = {
    id: "form_LpcoSrch",
    schema: {
        ...COMN_SF_LPCO_SRCH,
    },
};

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_LIST_R: TGridSchema = {
    id: "grid_lpcoList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 410,
    },
    head: [
        ...COMN_SG_LPCO_LIST_HEAD,
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 80 }] } /* Use Yn */,
        { cells: [{ header: "L_NO_ASNMT_CTRA", binding: "cnt", width: "15%" }] } /* Number of Assignment */,
    ],
    body: [
        ...COMN_SG_LPCO_LIST_BODY,
        {
            cells: [
                {
                    binding: "useYn",
                    align: "center",
                    area: "comnCd",
                    comnCd: "OSC0101",
                    type: "select",
                    viewType: "value",
                },
            ],
        },
        { cells: [{ binding: "cnt", align: "center", type: "number" }] },
    ],
};

// LPCO Assignment Schema !== LPCO Assignment Schema ==!
export const SG_LPCO_ASINCTRA_LIST_U: TGridSchema = {
    id: "grid_cpntRList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: false, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 300,
    },
    head: [
        { cells: [{ header: "L_OFCR_ROLE", binding: "asnmtOfcrTpCd", width: "*" }] } /* Process Name */,
        { cells: [{ header: "L_ASIN_CTRA", binding: "asinMetdCd", width: "*" }] } /* Process Name */,
        // { cells: [{ header: "L_DESC", binding: "asinDesc", width: "*" }] } /* Descriptions */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0119",
                    area: "comnCd",
                    edit: true,
                    required: true,
                    //excludes: ["AC", "MA", "DT", "LC", "CC"],
                    filter: (args: any) => {
                        return (
                            /** lpco officer type code */
                            // ["VE", "VA", "IP", "AC", "FR", "EV", "ES", "EF"].indexOf(args.value) > -1
                            ["VE", "VA", "IP", "FP", "FR"].indexOf(args.value) > -1
                        );
                    },
                },
            ],
        },
        {
            cells: [
                {
                    binding: "asinMetdCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0038",
                    area: "comnCd",
                    edit: true,
                    required: true,
                    excludes: ["0", "C"],
                },
            ],
        },
        // { cells: [{ binding: "asinDesc", align: "left", type: "text", edit: true }] },
    ],
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_ASINCTRA_LIST_R: TGridSchema = {
    id: "grid_cpntRList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [
        { cells: [{ header: "L_OFCR_ROLE", binding: "asnmtOfcrTpCd", width: "*" }] } /* Process Name */,
        { cells: [{ header: "L_ASIN_CTRA", binding: "asinMetdCd", width: "*" }] } /* Process Name */,
        // { cells: [{ header: "L_DESC", binding: "asinDesc", width: "*" }] } /* Descriptions */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0119",
                    area: "comnCd",
                    //excludes: ["AC", "MA", "DT", "LC", "CC"],
                    filter: (args: any) => {
                        return (
                            /** lpco officer type code */
                            ["VE", "VA", "IP", "FP", "FR", "EV", "ES", "EF"].indexOf(args.value) > -1
                        );
                    },
                },
            ],
        },
        {
            cells: [
                {
                    binding: "asinMetdCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0038",
                    area: "comnCd",
                    excludes: ["0", "C"],
                },
            ],
        },
        // { cells: [{ binding: "asinDesc", align: "left", type: "text", edit: true }] },
    ],
};
